import { createContext } from "react";

export const XORContext: any = createContext<any>(null);